import { useTranslation } from 'react-i18next'

import { Box, VStack } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'
import type { ApproverIdentity } from '~/pages/SpotBidding/models/approverIdentity'
import { buildApproverStandingNotices } from '~/pages/SpotBidding/models/approverIdentity'

/**
 * 承認・差戻しボタンの近くに常時出す注意 (AC-APT-019a (a))。 8080 プロトの承認案件一覧と同じ
 * warning の Alert (アイコン付き)。 承認者でなく申請者本人でもある時は 1 文にまとめる
 * (`buildApproverStandingNotices`)。 操作列は sticky で幅を取れないので折り返す幅に抑える。
 */
export const ApproverRowNotice = ({
  identity,
}: {
  identity: ApproverIdentity
}): React.ReactElement | null => {
  const { t } = useTranslation()
  const notices = buildApproverStandingNotices(identity, t)
  if (notices.length === 0) return null
  return (
    <Box maxWidth="320px" textAlign="left">
      <VStack align="stretch" gap={1}>
        {notices.map((notice) => (
          <CompactAlert key={notice} status="warning" title={notice} />
        ))}
      </VStack>
    </Box>
  )
}
